import IconWrapperProps from './type';
import { IconWrapperStyled, WrapperStyled } from './styled';

const Icon = ({ ...props }: IconWrapperProps) => {
  const { style, styleIcon, ...rest } = props;
  return (
    <WrapperStyled id="iconWrapper" {...rest} style={style}>
      <IconWrapperStyled id="iconWrapper-content" {...rest} style={styleIcon} />
    </WrapperStyled>
  );
};

Icon.defaultProps = {
  size: '24px',
  name: 'doneOutlined',
};

export default Icon;
